import { useState } from 'react';

export type MapLayer = 'streets' | 'satellite' | 'terrain';

export const MAP_LAYERS: Record<MapLayer, { url: string; attribution: string; name: string }> = {
  streets: {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    name: 'Ruas',
  },
  satellite: {
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: '&copy; Esri, Maxar, Earthstar Geographics',
    name: 'Satélite',
  },
  terrain: {
    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://opentopomap.org">OpenTopoMap</a>',
    name: 'Terreno',
  },
};

export function useMapLayer(initial: MapLayer = 'streets') {
  const [layer, setLayer] = useState<MapLayer>(initial);
  return { layer, setLayer, config: MAP_LAYERS[layer] };
}
